export const DEFAULT_LANGUAGE_HEADER = 'x-default-language';
export const SUPPORTED_LANGUAGES_HEADER = 'x-supported-languages';
export const WILDCARD_DOMAINS_HEADER = 'x-wildcard-domains';
export const PATHS_INSTANCE_HOSTNAME_HEADER = 'x-paths-instance-hostname';
export const PATHS_INSTANCE_IDENTIFIER_HEADER = 'x-paths-instance-identifier';
export const THEME_IDENTIFIER_HEADER = 'x-theme-identifier';
export const BASE_PATH_HEADER = 'x-base-path';
export const REQUEST_CORRELATION_ID_HEADER = 'X-Correlation-ID';
export const MIDDLEWARE_RAN_HEADER = 'x-middleware-ran';
export const FORWARDED_FOR_HEADER = 'x-forwarded-for';
export const FORWARDED_HOST_HEADER = 'x-forwarded-host';
export const FORWARDED_PROTO_HEADER = 'x-forwarded-proto';
export const FORWARDED_HEADER = 'forwarded';
